"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__EXPERIMENTAL_STYLE_PROPERTY = exports.DEPRECATED_ENTRY_KEYS = void 0;

/**
 * Array of valid keys in a block type settings deprecation object.
 *
 * @type {string[]}
 */
var DEPRECATED_ENTRY_KEYS = ['attributes', 'supports', 'save', 'migrate', 'isEligible', 'apiVersion'];
exports.DEPRECATED_ENTRY_KEYS = DEPRECATED_ENTRY_KEYS;
var __EXPERIMENTAL_STYLE_PROPERTY = {
  '--wp--style--color--link': {
    value: ['color', 'link'],
    support: ['color', 'link']
  },
  background: {
    value: ['color', 'gradient'],
    support: ['color', 'gradients']
  },
  backgroundColor: {
    value: ['color', 'background'],
    support: ['color']
  },
  borderRadius: {
    value: ['border', 'radius'],
    support: ['__experimentalBorder', 'radius']
  },
  color: {
    value: ['color', 'text'],
    support: ['color']
  },
  fontFamily: {
    value: ['typography', 'fontFamily'],
    support: ['__experimentalFontFamily']
  },
  fontSize: {
    value: ['typography', 'fontSize'],
    support: ['fontSize']
  },
  fontStyle: {
    value: ['typography', 'fontStyle'],
    support: ['__experimentalFontStyle']
  },
  fontWeight: {
    value: ['typography', 'fontWeight'],
    support: ['__experimentalFontWeight']
  },
  lineHeight: {
    value: ['typography', 'lineHeight'],
    support: ['lineHeight']
  },
  padding: {
    value: ['spacing', 'padding'],
    support: ['spacing', 'padding'],
    properties: ['top', 'right', 'bottom', 'left']
  },
  textDecoration: {
    value: ['typography', 'textDecoration'],
    support: ['__experimentalTextDecoration']
  },
  textTransform: {
    value: ['typography', 'textTransform'],
    support: ['__experimentalTextTransform']
  }
};
exports.__EXPERIMENTAL_STYLE_PROPERTY = __EXPERIMENTAL_STYLE_PROPERTY;
//# sourceMappingURL=constants.js.map